import React, { createContext, useMemo } from 'react';

import { usePlatform } from 'hooks/platform';
import { SidebarItem } from 'types';

import useMobileNavigation, { MobileNavigationResult } from './useMobileNavigation';
import usePlugins from './usePlugins';
import useSidebarNavigation, { NavigationResult } from './useSidebarNavigation';

export type ModulesContextValue = {
  pluginsInitialized: boolean;
  mobileNavigation: MobileNavigationResult;
  sidebarNavigation: NavigationResult;
  routedModules: SidebarItem[];
};
export const ModulesContext = createContext<ModulesContextValue | null>(null);

type ModulesProviderProps = {
  children: React.ReactNode;
};

const ModulesProvider = ({ children }: ModulesProviderProps) => {
  const pluginsInitialized = usePlugins();
  const sidebarNavigation = useSidebarNavigation();
  const mobileNavigation = useMobileNavigation();

  const platformConfig = usePlatform();
  const { hideSidebarNavigation } = platformConfig;

  const contextValue = useMemo(
    () => ({
      pluginsInitialized,
      mobileNavigation,
      sidebarNavigation,
      routedModules: hideSidebarNavigation ? mobileNavigation.routedModules : sidebarNavigation.routedModules,
    }),
    [pluginsInitialized, mobileNavigation, sidebarNavigation, hideSidebarNavigation],
  );

  return <ModulesContext.Provider value={contextValue}>{children}</ModulesContext.Provider>;
};

export default ModulesProvider;
